import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import AboutPreview from './components/AboutPreview';
import CTABanner from './components/CTABanner';
import ServicesPreview from './components/ServicesPreview';
import WhyUsSection from './components/WhyUsSection';
import HowItWorks from './components/HowItWorks';
import ReviewsSection from './components/ReviewsSection';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutPreview />
        <CTABanner />
        <ServicesPreview />
        <WhyUsSection />
        <HowItWorks />
        <ReviewsSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}